// Сохранение глубины ленивой подгрузки при перезагрузке досок (бронирования,
// машины). Колонки подгружаются страницами по perPage; перезагрузка идёт одним
// запросом на все колонки с общим per_page, поэтому:
//   - просим глубину самой глубокой колонки, округлённую ВВЕРХ до целых страниц
//     (после частичной страницы следующий loadMore иначе начнёт с дырой) и не
//     выше серверного потолка;
//   - страницу восстанавливаем по per_page, который сервер ЭХОМ вернул в колонке
//     (board_column отдаёт {…, page, per_page}), а не по тому, что просили: если
//     потолок на сервере другой, клиентская константа соврёт, и loadMore(page + 1)
//     пропустит или задублирует строки. Некратный потолок округляем вниз и режем
//     хвост items до page * perPage — так следующий loadMore начинается ровно с
//     items.length.

export function reloadPerPage(lengths, perPage, maxPerPage) {
  const deepest = lengths.reduce((max, n) => Math.max(max, n || 0), 0);
  const pages = Math.max(1, Math.ceil(deepest / perPage));
  return Math.min(pages * perPage, maxPerPage);
}

export function restoreDepth(items, appliedPerPage, perPage) {
  const applied = Number(appliedPerPage) || 0;
  const page = Math.max(1, Math.floor(applied / perPage));
  const limit = page * perPage;
  return { page, items: items.length > limit ? items.slice(0, limit) : items };
}
